<div class="pb-4">
  <div class="relative flex items-center justify-center">
    <button
      mat-button
      (click)="onClose()"
      type="button"
      aria-label="Close dialog"
      class="tertiary absolute top-1/2 left-0 -translate-y-1/2"
    >
      <mat-icon>close</mat-icon>
    </button>

    @if (title()) {
      <h2 mat-dialog-title class="mx-12 text-center text-2xl font-semibold">
        {{ title() }}
      </h2>
    }
  </div>
</div>
@if (title()) {
  <mat-divider></mat-divider>
}

<mat-dialog-content class="py-4">
  <ng-content select="[dialog-content]"></ng-content>
</mat-dialog-content>

@if (!hideActions()) {
  <mat-dialog-actions>
    @if (!hideCancel()) {
      <button mat-button (click)="onClose()">Annuler</button>
    }
    <ng-content select="[dialog-actions]"></ng-content>
  </mat-dialog-actions>
}
